/* ==========================================================================
   pdp-custom.js — Sri Annapurna custom Product Details Page

   COMPLETE FIXED VERSION

   - Product variants
   - Price switching
   - Availability
   - Multiple-image Variant Gallery
   - Product Media fallback
   - Quantity
   - Add to Cart
   - Buy Now
   - Cart counter
   - Wishlist
   - Tabs
   - FAQ
   - Delivery check
   ========================================================================== */

(function () {

  'use strict';


  /* =========================================================
     ROOT
  ========================================================= */

  var root =
    document.querySelector(
      '[data-sa-pdp]'
    );

  if (!root) {
    return;
  }


  /* =========================================================
     VARIANTS
  ========================================================= */

  var dataEl =
    root.querySelector(
      '[data-sa-variants]'
    );

  var variants = [];

  if (dataEl) {

    try {

      variants =
        JSON.parse(
          dataEl.textContent
        );

    } catch (error) {

      variants =
        [];

    }

  }


  /* =========================================================
     ELEMENTS
  ========================================================= */

  var form =
    root.querySelector(
      '[data-sa-form]'
    );

  var idInput =
    root.querySelector(
      '[data-sa-variant-id]'
    );

  var addBtn =
    root.querySelector(
      '[data-sa-add]'
    );

  var buyBtn =
    root.querySelector(
      '[data-sa-buy]'
    );

  var statusEl =
    root.querySelector(
      '[data-sa-status]'
    );

  var qtyInput =
    root.querySelector(
      '[data-sa-qty]'
    );

  var stockNote =
    root.querySelector(
      '[data-sa-stock]'
    );

  var priceEl =
    root.querySelector(
      '[data-sa-price]'
    );

  var unitEl =
    root.querySelector(
      '[data-sa-price-unit]'
    );

  var compareEl =
    root.querySelector(
      '[data-sa-compare]'
    );

  var discountEl =
    root.querySelector(
      '[data-sa-discount]'
    );


  /* =========================================================
     SETTINGS
  ========================================================= */

  var moneyFormat =
    root.getAttribute(
      'data-money-format'
    ) ||
    '\u20B9{{amount_no_decimals}}';

  var productUrl =
    root.getAttribute(
      'data-product-url'
    ) ||
    window.location.pathname;

  var hasDrawer =
    root.getAttribute(
      'data-cart-drawer'
    ) === 'true';


  /* =========================================================
     MONEY
  ========================================================= */

  function group(
    num,
    decimals
  ) {

    var parts =
      num
        .toFixed(decimals)
        .split('.');

    var whole =
      parts[0];

    var negative =
      whole.charAt(0) === '-';

    if (negative) {

      whole =
        whole.slice(1);

    }

    var last3 =
      whole.slice(-3);

    var rest =
      whole.slice(
        0,
        -3
      );

    if (rest) {

      last3 =
        rest.replace(
          /\B(?=(\d{2})+(?!\d))/g,
          ','
        ) +
        ',' +
        last3;

    }

    if (negative) {

      last3 =
        '-' + last3;

    }

    return parts[1]
      ? last3 + '.' + parts[1]
      : last3;

  }


  function formatMoney(
    cents
  ) {

    var value =
      cents / 100;

    return moneyFormat.replace(

      /\{\{\s*(\w+)\s*\}\}/g,

      function (
        _,
        token
      ) {

        switch (token) {

          case 'amount_no_decimals':

          case 'amount_no_decimals_with_comma_separator':

            return group(
              value,
              0
            );

          case 'amount_with_comma_separator':

            return group(
              value,
              2
            )
              .replace(
                /,/g,
                '\u0000'
              )
              .replace(
                '.',
                ','
              )
              .replace(
                /\u0000/g,
                '.'
              );

          default:

            return group(
              value,
              2
            );

        }

      }

    );

  }


  /* =========================================================
     OPTIONS
  ========================================================= */

  var optionButtons =
    Array.prototype.slice.call(

      root.querySelectorAll(
        '[data-sa-option]'
      )

    );


  function selectedOptions() {

    var selected =
      [];

    optionButtons.forEach(
      function (button) {

        if (
          button.classList.contains(
            'sel'
          )
        ) {

          selected[
            parseInt(
              button.getAttribute(
                'data-option-position'
              ),
              10
            ) - 1
          ] =
            button.getAttribute(
              'data-option-value'
            );

        }

      }
    );

    return selected;

  }


  function findVariant(
    options
  ) {

    for (
      var i = 0;
      i < variants.length;
      i++
    ) {

      var match =
        true;

      for (
        var j = 0;
        j < options.length;
        j++
      ) {

        if (
          options[j] != null &&
          variants[i].options[j] !==
            options[j]
        ) {

          match =
            false;

          break;

        }

      }

      if (match) {

        return variants[i];

      }

    }

    return null;

  }


  function markUnavailable(
    options
  ) {

    optionButtons.forEach(
      function (button) {

        var position =
          parseInt(
            button.getAttribute(
              'data-option-position'
            ),
            10
          ) - 1;

        var value =
          button.getAttribute(
            'data-option-value'
          );

        var purchasable =
          variants.some(
            function (variant) {

              if (
                variant.options[position] !==
                value
              ) {

                return false;

              }

              for (
                var j = 0;
                j < options.length;
                j++
              ) {

                if (
                  j !== position &&
                  options[j] != null &&
                  variant.options[j] !==
                    options[j]
                ) {

                  return false;

                }

              }

              return variant.available;

            }
          );

        button.classList.toggle(
          'is-unavailable',
          !purchasable
        );

      }
    );

  }


  /* =========================================================
     GALLERY
  ========================================================= */

  function showMedia(
    mediaId
  ) {

    if (
      mediaId == null
    ) {

      return;

    }

    var targetId =
      String(
        mediaId
      );


    root
      .querySelectorAll(
        '[data-sa-media]'
      )
      .forEach(
        function (element) {

          var visible =
            !element.classList.contains(
              'gallery-source-hidden'
            );

          var active =
            visible &&
            element.getAttribute(
              'data-media-id'
            ) ===
              targetId;

          element.classList.toggle(
            'active',
            active
          );

        }
      );


    root
      .querySelectorAll(
        '[data-sa-thumb]'
      )
      .forEach(
        function (element) {

          var visible =
            !element.classList.contains(
              'gallery-source-hidden'
            );

          var active =
            visible &&
            element.getAttribute(
              'data-media-id'
            ) ===
              targetId;

          element.classList.toggle(
            'active',
            active
          );

          element.setAttribute(
            'aria-current',
            active
              ? 'true'
              : 'false'
          );

        }
      );

  }


  /* =========================================================
     SWITCH WHOLE GALLERY

     Variant has custom.variant_gallery:
     → show that gallery only

     Variant has no custom gallery:
     → show normal Shopify product.media
  ========================================================= */

  function switchGalleryForVariant(
    variant
  ) {

    if (!variant) {

      return;

    }

    var variantId =
      String(
        variant.id
      );


    var allMedia =
      Array.prototype.slice.call(

        root.querySelectorAll(
          '[data-sa-media]'
        )

      );


    var allThumbs =
      Array.prototype.slice.call(

        root.querySelectorAll(
          '[data-sa-thumb]'
        )

      );


    var variantMedia =
      allMedia.filter(
        function (element) {

          return (

            element.getAttribute(
              'data-gallery-source'
            ) ===
              'variant' &&

            element.getAttribute(
              'data-gallery-variant-id'
            ) ===
              variantId

          );

        }
      );


    var hasVariantGallery =
      variantMedia.length > 0;


    /* MAIN MEDIA */

    allMedia.forEach(
      function (element) {

        var source =
          element.getAttribute(
            'data-gallery-source'
          );

        var galleryVariantId =
          element.getAttribute(
            'data-gallery-variant-id'
          );

        var showElement =
          false;


        if (hasVariantGallery) {

          showElement =
            source ===
              'variant' &&

            galleryVariantId ===
              variantId;

        } else {

          showElement =
            source ===
              'product';

        }


        element.classList.toggle(
          'gallery-source-hidden',
          !showElement
        );


        if (!showElement) {

          element.classList.remove(
            'active'
          );

        }

      }
    );


    /* THUMBNAILS */

    allThumbs.forEach(
      function (element) {

        var source =
          element.getAttribute(
            'data-gallery-source'
          );

        var galleryVariantId =
          element.getAttribute(
            'data-gallery-variant-id'
          );

        var showElement =
          false;


        if (hasVariantGallery) {

          showElement =
            source ===
              'variant' &&

            galleryVariantId ===
              variantId;

        } else {

          showElement =
            source ===
              'product';

        }


        element.classList.toggle(
          'gallery-source-hidden',
          !showElement
        );


        if (!showElement) {

          element.classList.remove(
            'active'
          );

          element.setAttribute(
            'aria-current',
            'false'
          );

        }

      }
    );


    /* =====================================================
       CUSTOM VARIANT GALLERY
    ====================================================== */

    if (hasVariantGallery) {

      showMedia(

        variantMedia[0]
          .getAttribute(
            'data-media-id'
          )

      );

      return;

    }


    /* =====================================================
       PRODUCT MEDIA FALLBACK
    ====================================================== */

    if (
      variant.featured_media_id
    ) {

      var featuredMedia =
        root.querySelector(

          '[data-sa-media]' +
          '[data-gallery-source="product"]' +
          '[data-media-id="' +
          String(
            variant.featured_media_id
          ) +
          '"]'

        );


      if (featuredMedia) {

        showMedia(
          variant.featured_media_id
        );

        return;

      }

    }


    var firstProductMedia =
      root.querySelector(

        '[data-sa-media]' +
        '[data-gallery-source="product"]'

      );


    if (firstProductMedia) {

      showMedia(

        firstProductMedia
          .getAttribute(
            'data-media-id'
          )

      );

    }

  }


  /* =========================================================
     THUMBNAIL CLICK
  ========================================================= */

  root
    .querySelectorAll(
      '[data-sa-thumb]'
    )
    .forEach(
      function (thumbnail) {

        thumbnail.addEventListener(
          'click',
          function (event) {

            event.preventDefault();


            if (
              thumbnail.classList.contains(
                'gallery-source-hidden'
              )
            ) {

              return;

            }


            showMedia(

              thumbnail.getAttribute(
                'data-media-id'
              )

            );

          }
        );

      }
    );


  /* =========================================================
     RENDER VARIANT
  ========================================================= */

  function render(
    variant
  ) {

    if (!variant) {

      if (addBtn) {

        addBtn.disabled =
          true;

        addBtn.textContent =
          'Unavailable';

      }

      if (buyBtn) {

        buyBtn.disabled =
          true;

      }

      return;

    }


    if (idInput) {

      idInput.value =
        variant.id;

    }


    if (priceEl) {

      priceEl.textContent =
        formatMoney(
          variant.price
        );

    }


    if (unitEl) {

      unitEl.textContent =
        variant.title &&
        variant.title !==
          'Default Title'
          ? '/ ' +
            variant.title
          : '';

    }


    var onSale =
      variant.compare_at_price &&
      variant.compare_at_price >
        variant.price;


    if (compareEl) {

      compareEl.textContent =
        onSale
          ? formatMoney(
              variant.compare_at_price
            )
          : '';

      compareEl.hidden =
        !onSale;

    }


    if (discountEl) {

      var percentage =
        onSale
          ? Math.round(
              (
                1 -
                variant.price /
                  variant.compare_at_price
              ) *
                100
            )
          : 0;

      discountEl.textContent =
        onSale
          ? 'Save ' +
            percentage +
            '%'
          : '';

      discountEl.hidden =
        !onSale;

    }


    /* STOCK */

    if (stockNote) {

      var label =
        stockNote.querySelector(
          '[data-sa-stock-text]'
        ) ||
        stockNote;

      stockNote.classList.remove(
        'is-out',
        'is-low'
      );


      if (
        !variant.available
      ) {

        label.textContent =
          'Currently Unavailable';

        stockNote.classList.add(
          'is-out'
        );


      } else if (

        variant.inventory_management &&

        variant.inventory_policy ===
          'deny' &&

        variant.inventory_quantity > 0 &&

        variant.inventory_quantity <= 10

      ) {

        label.textContent =
          'Only ' +
          variant.inventory_quantity +
          ' left';

        stockNote.classList.add(
          'is-low'
        );


      } else {

        label.textContent =
          'In Stock — Ships Today';

      }

    }


    if (addBtn) {

      addBtn.disabled =
        !variant.available;

      addBtn.textContent =
        variant.available
          ? 'Add to Cart'
          : 'Sold Out';

    }


    if (buyBtn) {

      buyBtn.disabled =
        !variant.available;

    }


    if (
      qtyInput &&
      variant.inventory_management &&
      variant.inventory_policy ===
        'deny'
    ) {

      qtyInput.max =
        variant.inventory_quantity >
        0
          ? variant.inventory_quantity
          : 1;

    } else if (
      qtyInput
    ) {

      qtyInput.removeAttribute(
        'max'
      );

    }


    /* IMPORTANT NEW GALLERY SWITCH */

    switchGalleryForVariant(
      variant
    );


    /* UPDATE URL */

    if (
      window.history &&
      history.replaceState
    ) {

      history.replaceState(

        {},

        '',

        productUrl +
          '?variant=' +
          variant.id

      );

    }

  }


  /* =========================================================
     OPTION CLICKS
  ========================================================= */

  optionButtons.forEach(
    function (button) {

      button.addEventListener(
        'click',
        function () {

          var position =
            button.getAttribute(
              'data-option-position'
            );


          optionButtons.forEach(
            function (option) {

              if (

                option.getAttribute(
                  'data-option-position'
                ) ===
                  position

              ) {

                option.classList.remove(
                  'sel'
                );

                option.setAttribute(
                  'aria-pressed',
                  'false'
                );

              }

            }
          );


          button.classList.add(
            'sel'
          );

          button.setAttribute(
            'aria-pressed',
            'true'
          );


          var label =
            root.querySelector(

              '[data-sa-option-label="' +
              position +
              '"]'

            );


          if (label) {

            label.textContent =
              button.getAttribute(
                'data-option-value'
              );

          }


          var options =
            selectedOptions();


          markUnavailable(
            options
          );


          render(

            findVariant(
              options
            )

          );

        }
      );

    }
  );


  /* =========================================================
     QUANTITY
  ========================================================= */

  root
    .querySelectorAll(
      '[data-sa-qty-step]'
    )
    .forEach(
      function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            if (!qtyInput) {

              return;

            }


            var delta =
              parseInt(

                button.getAttribute(
                  'data-sa-qty-step'
                ),

                10

              );


            var min =
              parseInt(
                qtyInput.min,
                10
              ) ||
              1;


            var max =
              parseInt(
                qtyInput.max,
                10
              ) ||
              Infinity;


            var next =
              (
                parseInt(
                  qtyInput.value,
                  10
                ) ||
                min
              ) +
              delta;


            qtyInput.value =
              Math.min(

                max,

                Math.max(
                  min,
                  next
                )

              );

          }
        );

      }
    );


  if (qtyInput) {

    qtyInput.addEventListener(
      'change',
      function () {

        var min =
          parseInt(
            qtyInput.min,
            10
          ) ||
          1;


        var max =
          parseInt(
            qtyInput.max,
            10
          ) ||
          Infinity;


        var value =
          parseInt(
            qtyInput.value,
            10
          );


        if (
          isNaN(value)
        ) {

          value =
            min;

        }


        qtyInput.value =
          Math.min(

            max,

            Math.max(
              min,
              value
            )

          );

      }
    );

  }


  /* =========================================================
     TABS
  ========================================================= */

  root
    .querySelectorAll(
      '[data-sa-tab]'
    )
    .forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            var name =
              button.getAttribute(
                'data-sa-tab'
              );


            root
              .querySelectorAll(
                '[data-sa-tab]'
              )
              .forEach(
                function (tab) {

                  var active =
                    tab === button;


                  tab.classList.toggle(
                    'active',
                    active
                  );


                  tab.setAttribute(
                    'aria-selected',
                    active
                      ? 'true'
                      : 'false'
                  );

                }
              );


            root
              .querySelectorAll(
                '[data-sa-panel]'
              )
              .forEach(
                function (panel) {

                  panel.style.display =
                    panel.getAttribute(
                      'data-sa-panel'
                    ) ===
                      name
                      ? 'block'
                      : 'none';

                }
              );

          }
        );

      }
    );


  /* =========================================================
     FAQ
  ========================================================= */

  root
    .querySelectorAll(
      '[data-sa-faq-toggle]'
    )
    .forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            var expanded =
              button.getAttribute(
                'aria-expanded'
              ) ===
                'true';


            var panel =
              button.parentElement
                .querySelector(
                  '[data-sa-faq-panel]'
                );


            button.setAttribute(

              'aria-expanded',

              expanded
                ? 'false'
                : 'true'

            );


            if (panel) {

              panel.hidden =
                expanded;

            }

          }
        );

      }
    );


  /* =========================================================
     CART
  ========================================================= */

  function setStatus(
    message,
    isError
  ) {

    if (!statusEl) {

      return;

    }


    statusEl.textContent =
      message ||
      '';


    statusEl.classList.toggle(
      'is-error',
      !!isError
    );


    statusEl.hidden =
      !message;

  }


  function sectionsToRender() {

    var ids =
      [];


    if (
      document.querySelector(
        'cart-drawer'
      )
    ) {

      ids.push(
        'cart-drawer'
      );

    }


    if (
      document.getElementById(
        'cart-icon-bubble'
      )
    ) {

      ids.push(
        'cart-icon-bubble'
      );

    }


    return ids;

  }


  function applySections(
    sections
  ) {

    if (!sections) {

      return;

    }


    Object.keys(
      sections
    ).forEach(
      function (id) {

        var parsed =
          new DOMParser()
            .parseFromString(
              sections[id],
              'text/html'
            );


        var incoming =
          parsed.querySelector(
            '.shopify-section'
          ) ||
          parsed.body.firstElementChild;


        var target =
          document.getElementById(
            'shopify-section-' +
            id
          ) ||
          document.getElementById(
            id
          );


        if (
          incoming &&
          target
        ) {

          target.innerHTML =
            incoming.innerHTML;

        }

      }
    );

  }


  function refreshCartCount() {

    return fetch(

      '/cart.js',

      {
        headers: {
          Accept:
            'application/json'
        }
      }

    )
      .then(
        function (response) {

          return response.json();

        }
      )

      .then(
        function (cart) {


          document
            .querySelectorAll(
              '[data-cart-count]'
            )
            .forEach(
              function (element) {

                element.textContent =
                  cart.item_count;

              }
            );


          document
            .querySelectorAll(
              '.cart-count-badge'
            )
            .forEach(
              function (element) {

                var count =
                  Number(
                    cart.item_count ||
                    0
                  );


                element.textContent =
                  count > 99
                    ? '99+'
                    : count;


                element.hidden =
                  count <= 0;

              }
            );


          document.dispatchEvent(

            new CustomEvent(
              'cart:updated',
              {
                detail: {
                  cart:
                    cart
                }
              }
            )

          );


          return cart;

        }
      )

      .catch(
        function () {
          /* cosmetic only */
        }
      );

  }


  function addToCart(
    destination
  ) {

    if (!form) {

      return Promise.resolve();

    }


    var body =
      new FormData(
        form
      );


    var ids =
      sectionsToRender();


    if (
      ids.length
    ) {

      body.append(
        'sections',
        ids.join(',')
      );

    }


    var button =
      destination ===
        'checkout'
        ? buyBtn
        : addBtn;


    if (button) {

      button.classList.add(
        'is-loading'
      );

      button.disabled =
        true;

    }


    setStatus(
      ''
    );


    return fetch(

      '/cart/add.js',

      {
        method:
          'POST',

        headers: {
          Accept:
            'application/javascript'
        },

        body:
          body
      }

    )
      .then(
        function (response) {

          return response
            .json()
            .then(
              function (data) {

                if (
                  !response.ok
                ) {

                  throw new Error(

                    data.description ||
                    data.message ||
                    'Could not add to cart'

                  );

                }


                return data;

              }
            );

        }
      )

      .then(
        function (item) {


          if (
            destination ===
            'checkout'
          ) {

            window.location.href =
              '/checkout';

            return;

          }


          applySections(
            item.sections
          );


          setStatus(
            'Added to your cart.'
          );


          if (hasDrawer) {

            var drawer =
              document.querySelector(
                'cart-drawer'
              );


            if (
              drawer &&
              typeof drawer.open ===
                'function'
            ) {

              drawer.open();

            }

          }


          return refreshCartCount();

        }
      )

      .catch(
        function (error) {

          setStatus(
            error.message,
            true
          );

        }
      )

      .finally(
        function () {

          if (
            button &&
            destination !==
              'checkout'
          ) {

            button.classList.remove(
              'is-loading'
            );

            button.disabled =
              false;

          }

        }
      );

  }


  if (form) {

    form.addEventListener(
      'submit',
      function (event) {

        event.preventDefault();

        addToCart(
          'stay'
        );

      }
    );

  }


  if (buyBtn) {

    buyBtn.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        addToCart(
          'checkout'
        );

      }
    );

  }


  /* =========================================================
     WISHLIST
  ========================================================= */

  var wishBtn =
    root.querySelector(
      '[data-sa-wish]'
    );


  var WISHLIST_KEY =
    'annapurnaWishlistV1';


  var OLD_WISHLIST_KEY =
    'sa_wishlist';


  function wishlistProductKey(
    url
  ) {

    if (!url) {

      return '';

    }


    try {

      var parsed =
        new URL(
          url,
          window.location.origin
        );


      return parsed.pathname
        .replace(
          /\/$/,
          ''
        );


    } catch (error) {


      return String(
        url
      )
        .split('?')[0]
        .replace(
          /\/$/,
          ''
        );

    }

  }


  function readWishlist() {

    try {

      var parsed =
        JSON.parse(

          localStorage.getItem(
            WISHLIST_KEY
          ) ||
          '{}'

        );


      if (
        parsed &&
        typeof parsed ===
          'object' &&
        !Array.isArray(parsed)
      ) {

        return parsed;

      }


      return {};


    } catch (error) {

      return {};

    }

  }


  function writeWishlist(
    wishlist
  ) {

    try {

      localStorage.setItem(

        WISHLIST_KEY,

        JSON.stringify(
          wishlist
        )

      );


      return true;


    } catch (error) {

      console.error(
        '[Sri Annapurna] Wishlist could not be saved:',
        error
      );


      return false;

    }

  }


  function currentProductTitle() {

    var title =
      root.querySelector(
        '.pdp-info h1'
      );


    return title
      ? title.textContent.trim()
      : document.title;

  }


  function currentProductImage() {

    var activeImage =
      root.querySelector(
        '[data-sa-media].active img'
      );


    if (activeImage) {

      return (
        activeImage.currentSrc ||
        activeImage.src ||
        ''
      );

    }


    var firstImage =
      root.querySelector(
        '[data-sa-media]:not(.gallery-source-hidden) img'
      );


    if (firstImage) {

      return (
        firstImage.currentSrc ||
        firstImage.src ||
        ''
      );

    }


    return '';

  }


  function setWishButtonState(
    active
  ) {

    if (!wishBtn) {

      return;

    }


    wishBtn.classList.toggle(
      'is-saved',
      active
    );


    wishBtn.setAttribute(
      'aria-pressed',
      active
        ? 'true'
        : 'false'
    );


    wishBtn.setAttribute(

      'aria-label',

      active
        ? 'Remove ' +
          currentProductTitle() +
          ' from wishlist'

        : 'Save ' +
          currentProductTitle() +
          ' to wishlist'

    );

  }


  function updateWishlistHeaderCount(
    wishlist
  ) {

    var count =
      Object.keys(
        wishlist ||
        {}
      ).length;


    document
      .querySelectorAll(
        '.wishlist-count-badge'
      )
      .forEach(
        function (badge) {

          badge.textContent =
            count > 99
              ? '99+'
              : count;


          badge.hidden =
            count <= 0;

        }
      );

  }


  function dispatchWishlistUpdate(
    wishlist,
    productKey,
    added
  ) {

    updateWishlistHeaderCount(
      wishlist
    );


    document.dispatchEvent(

      new CustomEvent(
        'annapurna:wishlist-change',

        {
          detail: {
            wishlist:
              wishlist,

            productUrl:
              productKey,

            added:
              added
          }
        }

      )

    );

  }


  function migrateCurrentProductFromOldWishlist() {

    if (!wishBtn) {

      return;

    }


    var handle =
      wishBtn.getAttribute(
        'data-sa-wish'
      ) ||
      '';


    if (!handle) {

      return;

    }


    var oldList =
      [];


    try {

      oldList =
        JSON.parse(

          localStorage.getItem(
            OLD_WISHLIST_KEY
          ) ||
          '[]'

        );


      if (
        !Array.isArray(
          oldList
        )
      ) {

        oldList =
          [];

      }


    } catch (error) {

      oldList =
        [];

    }


    if (
      oldList.indexOf(
        handle
      ) === -1
    ) {

      return;

    }


    var key =
      wishlistProductKey(
        productUrl
      );


    if (!key) {

      return;

    }


    var wishlist =
      readWishlist();


    if (
      !wishlist[key]
    ) {

      wishlist[key] = {

        url:
          key,

        title:
          currentProductTitle(),

        image:
          currentProductImage(),

        handle:
          handle,

        addedAt:
          Date.now()

      };


      writeWishlist(
        wishlist
      );

    }


    oldList =
      oldList.filter(
        function (item) {

          return item !==
            handle;

        }
      );


    try {

      localStorage.setItem(

        OLD_WISHLIST_KEY,

        JSON.stringify(
          oldList
        )

      );


    } catch (error) {
      /* ignore */
    }

  }


  if (wishBtn) {

    var wishlistHandle =
      wishBtn.getAttribute(
        'data-sa-wish'
      ) ||
      '';


    var wishlistProductUrl =
      wishlistProductKey(
        productUrl
      );


    migrateCurrentProductFromOldWishlist();


    var initialWishlist =
      readWishlist();


    var initiallySaved =
      Boolean(

        wishlistProductUrl &&

        initialWishlist[
          wishlistProductUrl
        ]

      );


    setWishButtonState(
      initiallySaved
    );


    updateWishlistHeaderCount(
      initialWishlist
    );


    wishBtn.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        event.stopPropagation();


        var wishlist =
          readWishlist();


        var isSaved =
          Boolean(

            wishlist[
              wishlistProductUrl
            ]

          );


        if (isSaved) {

          delete wishlist[
            wishlistProductUrl
          ];


        } else {

          wishlist[
            wishlistProductUrl
          ] = {

            url:
              wishlistProductUrl,

            title:
              currentProductTitle(),

            image:
              currentProductImage(),

            handle:
              wishlistHandle,

            addedAt:
              Date.now()

          };

        }


        if (
          !writeWishlist(
            wishlist
          )
        ) {

          return;

        }


        var nowSaved =
          !isSaved;


        setWishButtonState(
          nowSaved
        );


        dispatchWishlistUpdate(

          wishlist,

          wishlistProductUrl,

          nowSaved

        );

      }
    );

  }


  window.addEventListener(
    'storage',
    function (event) {

      if (
        event.key !==
        WISHLIST_KEY
      ) {

        return;

      }


      var wishlist =
        readWishlist();


      var key =
        wishlistProductKey(
          productUrl
        );


      if (wishBtn) {

        setWishButtonState(

          Boolean(
            key &&
            wishlist[key]
          )

        );

      }


      updateWishlistHeaderCount(
        wishlist
      );

    }
  );


  /* =========================================================
     PINCODE
  ========================================================= */

  var dcBtn =
    root.querySelector(
      '[data-sa-pincode-check]'
    );


  if (dcBtn) {

    var dcInput =
      root.querySelector(
        '[data-sa-pincode]'
      );


    var dcResult =
      root.querySelector(
        '[data-sa-pincode-result]'
      );


    var blocked =
      (
        root.getAttribute(
          'data-blocked-pincodes'
        ) ||
        ''
      )
        .split(',')

        .map(
          function (value) {
            return value.trim();
          }
        )

        .filter(Boolean);


    var eta =
      root.getAttribute(
        'data-delivery-eta'
      ) ||
      '2–4 days';


    var check =
      function () {

        var pin =
          (
            dcInput.value ||
            ''
          ).trim();


        if (!dcResult) {

          return;

        }


        dcResult.hidden =
          false;


        if (
          !/^\d{6}$/.test(
            pin
          )
        ) {

          dcResult.textContent =
            'Enter a valid 6-digit pincode.';


          dcResult.classList.add(
            'is-error'
          );


          return;

        }


        var isBlocked =
          blocked.some(
            function (value) {

              return (
                pin.indexOf(
                  value
                ) === 0
              );

            }
          );


        if (isBlocked) {

          dcResult.textContent =
            'We do not currently ship to ' +
            pin +
            '. Please contact us.';


          dcResult.classList.add(
            'is-error'
          );


        } else {

          dcResult.textContent =
            'Delivers to ' +
            pin +
            ' in ' +
            eta +
            '.';


          dcResult.classList.remove(
            'is-error'
          );

        }

      };


    dcBtn.addEventListener(
      'click',
      check
    );


    if (dcInput) {

      dcInput.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key ===
              'Enter'
          ) {

            event.preventDefault();

            check();

          }

        }
      );

    }

  }


  /* =========================================================
     INITIAL VARIANT
  ========================================================= */

  if (
    variants.length
  ) {

    var initial =
      selectedOptions();


    markUnavailable(
      initial
    );


    var current =
      findVariant(
        initial
      );


    if (current) {

      render(
        current
      );

    }

  }

})();